import { render, staticRenderFns } from "./product_popup.vue?vue&type=template&id=fa42b394&"
import script from "./product_popup.vue?vue&type=script&lang=js&"
export * from "./product_popup.vue?vue&type=script&lang=js&"
import style0 from "./product_popup.vue?vue&type=style&index=0&id=fa42b394&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports